import { Navigate, Route, Routes } from 'react-router-dom';
import GuardianHub from './guardian/GuardianHub';
import Splash from './Splash';

/**
 * The whole site is the Guardian hub, for everyone: signed out, the public pages work and the personal ones show a
 * sign-in card; signed in, it is your own Guardian. The welcome (Splash) sits over it on a signed-out first visit. No
 * footer, as in the app: the Bungie note is on Maps and the sign-in cards.
 */
export default function App() {
  return (
    <div className="site">
      <Routes>
        <Route path="/" element={<GuardianHub />} />
        <Route path="/guardian/:tab?/:sub?" element={<GuardianHub />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Splash />
    </div>
  );
}
